import { useContext, createContext, useEffect, useState } from 'react';
import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { auth } from '../firebase';

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);
  const [isFormSub, setFormSub] = useState(false);

  const removedata = () => {
    sessionStorage.setItem('hasSeenInstructionModal', 'true');
    signOut(auth);
  };

  const googleSignIn = () => {
    return new Promise((resolve, reject) => {
      setFormSub(true);
      sessionStorage.setItem('isFormSub', 'true');
      const provider = new GoogleAuthProvider();
      signInWithPopup(auth, provider)
        .then(resolve)
        .catch(reject);
    });
  };

  const googleSignedUser = () => {
    return new Promise((resolve, reject) => {
      setFormSub(false);
      sessionStorage.setItem('isFormSub', 'false');
      const provider = new GoogleAuthProvider();
      signInWithPopup(auth, provider)
        .then(resolve)
        .catch(reject);
    });
  };

  const logOut = () => {
    sessionStorage.setItem('hasSeenInstructionModal', 'true');
    signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthReady(true);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{
        googleSignIn,
        logOut,
        googleSignedUser,
        removedata,
        user,
        authReady,
        isFormSub,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(AuthContext);
};
